import classes from 'components/CheckStatus/CheckStatus.module.scss';
import Button from '@material-ui/core/Button';
import Constants from 'config/constants';
import { Format } from 'utils/Format';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

export default function CheckStatus(props) {
	const handleCallStore = () => {
		window.open(`tel:${props.store.phone},0,0`, '_self');
	};

	const buttonTheme = createMuiTheme({
		palette: {
			primary: {
				main: props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			}
		}
	});

	return (
		<div data-test-id="check-status-main">
			<div className={classes.CheckStatusContainer}>
				<ThemeProvider theme={buttonTheme}>
					<Button className={classes.CheckStatusBtn}
									color="primary"
									variant="contained"
									onClick={props.handleCheckStatus}>
						<p className="body-button">Check Status</p>
					</Button>
				</ThemeProvider>
				{props.queuePosition === 0 && Format.isEligibleForCallStore(new Date(props.checkInTime.replace(/\s/, 'T')+'Z')) &&
					<div className={classes.CallStoreBtnContainer}>
						<Button className={classes.CallStoreBtn}
										variant="outlined"
										onClick={handleCallStore}>
							<p className="body-button">Call Store</p>
						</Button>
					</div>
				}
			</div>
		</div>
	);
}
